import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {CorrespondenceDto} from "../correspondence.dto";
import {MediaFileType} from "../../../libs/enum/media-file-type.enum";
import {isDefined} from "../../../libs/utils/epic.utils";
import {SendType} from "../../../libs/enum/send-type.enum";
import {ContactType} from "../../../libs/enum/contact-type";
import {ContactDto} from "../contact.dto";

export class SearchCorrespondenceRes extends SearchResultDto {

  public override readonly items: SearchCorrespondenceItem[] = [];

  constructor(init?: Partial<SearchCorrespondenceRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchCorrespondenceItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchCorrespondenceItem extends CorrespondenceDto implements SearchItem {

  public override readonly id!: string;

  public readonly sendType: SendType | undefined;
  public readonly emailAddress: string | undefined;
  public readonly mediaId: string | undefined;
  public readonly mediaType: MediaFileType | undefined;
  public readonly mediaContentType: string | undefined;
  public readonly mediaFilename: string | undefined;
  public readonly contactId: string | undefined;
  public readonly contactType: ContactType | undefined;
  public readonly contactNumber: string | undefined;
  public readonly contactFullName: string | undefined;
  public readonly vehicleId: string | undefined;
  public readonly orgWalletTransactionId!: string;
  public readonly invoiceId: string | undefined;
  public readonly deliveryNoteId: string | undefined;
  public readonly proformaInvoiceId: string | undefined;
  public readonly searchId!: string;
  public readonly eventStatus: string | undefined;
  public readonly eventTimestamp: Date | undefined;

  constructor(init?: Partial<SearchCorrespondenceItem>) {
    super(init);
    Object.assign(this, init);
    if (isDefined(init?.eventTimestamp)) {
      this.eventTimestamp = new Date(init.eventTimestamp);
    }
  }

  public get contact(): ContactDto {
    return new ContactDto({
      id: this.contactId,
      type: this.contactType,
      number: this.contactNumber,
      fullName: this.contactFullName
    });
  }
}
